import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Header from '../../../common_components/Header';
import Footer from '../../../common_components/Footer';
import Drawer from '../../../common_components/Drawer';
import { sendPartnerRegistrationform_action, getPartnerStaticData_action, } from '../../../actions/partner_module_action/partner_registration_action/partner_registration_action';
import { getPartnerApplicationDetails_action, updatePartnerApplication_action, partnerDeleteDoc_action } from '../../../actions/partner_module_action/partner_application_action/partner_application_action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu"; import { withRouter } from '../../../utils/withRouter';
import moment from 'moment';
import Modal from "react-modal";
import Loader from '../../../utils/Loader'
import Select from 'react-select';
import {
    clearSessionStorage, countryActionId, notApplicableCountryActionId, noApplicableStateActionId, BASE_URL,
    stateActionId, cityActionId, pincodeActionId, verifyPrimaryEmailIDActionId, primaryChapterListActionId, onlinePresenceListActionId,
    toastError, toastSuccess
} from '../../../utils/constants'
import Pagination from '../../../utils/pagination'
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from '../../../actions/fillCombo_action'
import StepHeader from '../../registration/stepHeader';
import PrimaryChapter from '../../registration/primary_chapter';
import Description from '../../registration/description';
import Resizer from "react-image-file-resizer";
import { contactNoValidator, panNoValidator, tanNoValidator, gstNoValidator, emailValidator } from '../../../utils/Validator'
import $ from 'jquery'
import VisitorHeader from '../../../common_components/visitor_module_header';
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";

/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps
*/
const mapStateToProps = state => ({
    ...state
})

class PartnerApplication extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            isDisplayCountryList: false,
            isDisplayStateList: false,
            isDisplayCityList: false,
            isDocDeleted: true,
            isDisplayPincodeList: false,
            isAgree: false,
            isAgreeConsent: false,
            isDisplayCountryList2: false,
            isDelOpen: false,
            isPageValid: false,
            logoFilePath: '',
            ref: '',
            formID: 1,
            formName: 'Knowledge Partner',
            exhibitionID: '',
            countryList: [],
            tempCountryList: [],
            stateList: [],
            tempStateList: [],
            countryList2: [],
            tempCountryList2: [],
            cityList: [],
            tempCityList: [],
            pincodeList: [],
            tempPincodeList: [],
            selectedChapterList: [],
            list1: [{
                Deliverable: '',
                Quantity: '',
                ScheduleDuration: '',
            }],
            list2: [{
                FirstName: '',
                LastName: '',
                Designation: '',
                Email: '',
                Mobile: '',
                country: '',
                CountryID: '',
                isDisplayCountryList2: false
            }],
            offerList: [],

            TandC: [],

            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            primaryChapterListLevel2: [],
            primaryChapterListLevel3: [],
            primaryChapterListLevel4: [],
            level4DummyId: '',
            totalCirculationNo: '',

            totalCirculationList: [],
            selectedTotalCirculation: [],
            overseasCirculationList: [],
            selectedOverseasCirculation: [],
            regionsCoveredinIndiaList: [],
            selectedRegionsCoveredinIndia: [],
            onlinePresenceList: [],

            exhno: '',
            firstName: '',
            isOther_title_PersonIncharge: false,
            other_title_PersonIncharge: '',
            title_PersonIncharge: 'Mr',
            lastName: '',
            designation: '',
            companyName: '',
            fasciaName: '',
            add1: '',
            add2: '',
            country: '',
            state: '',
            city: '',
            Pin: '',
            countryId: '',
            preMobNo: '',
            altPreMobNo: '',
            mobNo: '',
            altMobNo: '',
            telNo: '',
            preTelNo: '',
            primaryEmail: '',
            secondaryEmail: '',
            website: '',

            logoImg: '',
            logoImgErr: '',
            logoImgType: '',

            //err
            countryErr: '',
            stateErr: '',
            cityErr: '',
            PinErr: '',
            firstNameErr: '',
            lastNameErr: '',
            designationErr: '',
            companyNameErr: '',
            add1Err: '',
            mobNoErr: '',
            emailErr: '',
            telNoErr: '',
            // onlinePresenceErr:'',
            RandRpath: '',
            undertakingContent: [],
            openPop4: false,

            AuthorizedPersonName: '',
            AuthorizedPersonNameErr: '',
            DesignationAuthorizedPerson: '',
            DesignationAuthorizedPersonErr: '',
            ExhibitorCompanyName: '',
            ExhibitorCompanyNameErr: '',
            EmailAuthorizedPerson: '',
            EmailAuthorizedPersonErr: '',
            MobileAuthorizedPerson: '',
            PreMobileAuthorizedPerson: '',
            MobileAuthorizedPersonErr: '',
        }
        this.pdfContainerRef = createRef();
        this.getFillList = this.getFillList.bind(this)
        this.onCitySearch = this.onCitySearch.bind(this)
        this.renderCityList = this.renderCityList.bind(this)
        this.onCountrySearch = this.onCountrySearch.bind(this)
        this.renderCountryList = this.renderCountryList.bind(this)
        this.onCountrySearch2 = this.onCountrySearch2.bind(this)
        this.renderCountryList2 = this.renderCountryList2.bind(this)
        this.onPincodeSearch = this.onPincodeSearch.bind(this)
        this.renderPincodeList = this.renderPincodeList.bind(this)
        this.onStateSearch = this.onStateSearch.bind(this)
        this.renderStateList = this.renderStateList.bind(this)
        this.preventMinus = this.preventMinus.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.OnAddList1 = this.OnAddList1.bind(this)
        this.OnAddList2 = this.OnAddList2.bind(this)
        this.enterDelivables = this.enterDelivables.bind(this)
        this.enterQuantity = this.enterQuantity.bind(this)
        this.enterSchedule = this.enterSchedule.bind(this)
        this.enterCountry = this.enterCountry.bind(this)
        this.selectCountry = this.selectCountry.bind(this)
        this.enterDesignation = this.enterDesignation.bind(this)
        this.enterEmail = this.enterEmail.bind(this)
        this.enterFirstName = this.enterFirstName.bind(this)
        this.enterLastName = this.enterLastName.bind(this)
        this.onDocDelete = this.onDocDelete.bind(this)
        this.handleDelete = this.handleDelete.bind(this)

        // this.onCheckLevel1 = this.onCheckLevel1.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        // this.record = this.record.bind(this)
        // this.recordThree = this.recordThree.bind(this)
        // this.recordTwo = this.recordTwo.bind(this)
        // this.updateChapterList = this.updateChapterList.bind(this)
        this.onChapterRemove = this.onChapterRemove.bind(this)

        this.handleTotalCirculationSelect = this.handleTotalCirculationSelect.bind(this)
        this.handleOverseasCirculationSelect = this.handleOverseasCirculationSelect.bind(this)
        this.handleRegionsCoveredinIndiaSelect = this.handleRegionsCoveredinIndiaSelect.bind(this)
        this.onOnlinePresenceSelect = this.onOnlinePresenceSelect.bind(this)

        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)

        this.getPartnerDetails = this.getPartnerDetails.bind(this)
        this.onSubmit = this.onSubmit.bind(this)


        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onSubmit()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        // var promise = new Promise((resolve, rej) => {
        this.getFillList(countryActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d1 => {
            this.getFillList(stateActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d2 => {
                this.getFillList(cityActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d3 => {
                    this.getFillList(pincodeActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d4 => {
                        this.getFillList(onlinePresenceListActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d5 => {
                            this.getFillList(notApplicableCountryActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d6 => {
                                this.getFillList(noApplicableStateActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(d7 => {
                                    this.getFillList(primaryChapterListActionId, JSON.parse(sessionStorage.getItem("sessionExhibitionID")), '', '', '', '').then(data => {
                                        this.setState({ RandRpath: sessionStorage.getItem("RulesAndRegulations") })
                                        console.log(data, d5, d1)
                                        this.getPartnerDetails()
                                    })
                                })
                            })
                        })
                    })
                })

            })
        })
        console.log(JSON.parse(sessionStorage.getItem('sessionHeaderData')),)
        console.log(JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['Flag'])
        // resolve(true)

        // })
        // promise.then((result) => {
        //     if (result) {
        //         console.log("result----------->", result, this.state.tempCountryList, this.state.tempCountryList2)
        //     }
        // })
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        return new Promise((resolve, reject) => {

            const { } = this.state
            this.setState({ isLoading: true })
            // var promise = new Promise((resolve, rej) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            var overseasList = []
                            data.data.length > 0 && data.data.filter(subdata => {
                                subdata.Code != 91 && overseasList.push(subdata)
                            })
                            this.setState({
                                countryList: data.data,
                                tempCountryList: data.data,
                                countryList2: data.data,
                                tempCountryList2: data.data,
                                // totalCirculationList: data.data,
                                // overseasCirculationList: overseasList
                            })
                            resolve(true)
                        }
                        if (actionID === notApplicableCountryActionId) {
                            console.log("country data", data.data)
                            var overseasList = []
                            data.data.length > 0 && data.data.filter(subdata => {
                                subdata.Code != 91 && overseasList.push(subdata)
                            })
                            this.setState({
                                // countryList: data.data,
                                // tempCountryList: data.data,
                                // countryList2: data.data,
                                // tempCountryList2: data.data,
                                // totalCirculationList: data.data,
                                overseasCirculationList: overseasList
                            })
                            resolve(true)
                        }
                        // state list
                        if (actionID === stateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                // regionsCoveredinIndiaList: data.data
                            })
                            resolve(true)
                        }
                        if (actionID === noApplicableStateActionId) {
                            console.log("stateList data", data.data)
                            this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                                regionsCoveredinIndiaList: data.data
                            })
                            resolve(true)
                        }
                        // city list
                        if (actionID === cityActionId) {
                            console.log("city data", data.data)
                            this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)

                        }
                        // pincode
                        if (actionID === pincodeActionId) {
                            console.log("pincode data", data.data)
                            this.setState({
                                pincodeList: data.data,
                                tempPincodeList: data.data,
                            })
                            resolve(true)

                        }
                        if (actionID === primaryChapterListActionId) {
                            for (let i = 0; i < data.data.level0.length; i++) {
                                data.data.level0[i]['Area'] = parseFloat(data.data.level0[i]['Length'] || 0) * parseFloat(data.data.level0[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level2.length; i++) {
                                data.data.level2[i]['Area'] = parseFloat(data.data.level2[i]['Length'] || 0) * parseFloat(data.data.level2[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level3.length; i++) {
                                data.data.level3[i]['Area'] = parseFloat(data.data.level3[i]['Length'] || 0) * parseFloat(data.data.level3[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.level4.length; i++) {
                                data.data.level4[i]['Area'] = parseFloat(data.data.level4[i]['Length'] || 0) * parseFloat(data.data.level4[i]['Breadth'] || 0)
                            }
                            for (let i = 0; i < data.data.primaryChapter.length; i++) {
                                data.data.primaryChapter[i]['Area'] = parseFloat(data.data.primaryChapter[i]['Length'] || 0) * parseFloat(data.data.primaryChapter[i]['Breadth'] || 0)
                            }
                            // this.setState({ isLoading: true })
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        if (arr[i].ChapterID == 2138) {

                                            // console.log(arr[i].ChapterName, i, arr[i].ChapterName[0], /^\d$/.test(arr[i].ChapterName[0]),)
                                        }
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        }
                                        else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                        if (arr[i].ChapterID == 2138) {

                                            // console.log('[][]', arr[i].ChapterName)
                                        }
                                    }
                                }
                                return
                            }
                            // console.log(data.data['level2'])

                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                seqnoFormat(data.data['level2'])
                            }
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    // console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            console.log("prr",)
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                for (var j = 0; j < data.data['level2'].length; j++) {
                                    if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                        data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                for (var j = 0; j < data.data['level3'].length; j++) {
                                    if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                        for (var k = 0; k < data.data['level2'].length; k++) {
                                            if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                break
                                            }
                                        }
                                        break
                                    }
                                }
                                seqnoFormat(data.data['level4'])
                            }

                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            data.data['primaryChapter'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level2'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level3'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            data.data['level4'].sort((a, b) => a.seqno.localeCompare(b.seqno, undefined, { numeric: true }));
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'],
                                level0: data.data['level0'],
                                level2: data.data['level2'],
                                level3: data.data['level3'],
                                level4: data.data['level4'],
                                // isLoading: false,
                            })
                            var list = []
                            // console.log("level2 get", level2)
                            data.data['level2'].length > 0 && data.data['level2'].map(level2Data => {
                                if (level2Data.IsSelect && level2Data.IsCheckbox) {
                                    // console.log("level2Data get", level2Data)

                                    list.push(level2Data)
                                }
                            })
                            data.data['level3'].length > 0 && data.data['level3'].map(level3Data => {
                                if (level3Data.IsSelect && level3Data.IsCheckbox) {
                                    list.push(level3Data)
                                }
                            })
                            data.data['level4'].length > 0 && data.data['level4'].map(level4Data => {
                                if (level4Data.IsSelect && level4Data.IsCheckbox) {
                                    list.push(level4Data)
                                }
                            })
                            list.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
                            data.data['level0'].length > 0 && data.data['level0'].map(level0Data => {
                                if (level0Data.IsSelect) {
                                    // console.log("level2Data get", level2Data)

                                    list.push(level0Data)
                                }
                            })
                            console.log("exhibitDetailsList get", list)
                            setTimeout(() => {
                                this.setState({ exhibitDetailsList: list })
                                // this.filterLevelData().then(() => {
                                // resolve(true)
                                // })
                                resolve(true)
                            }, 300);
                        }
                        if (actionID === onlinePresenceListActionId) {
                            console.log(" data", data.data)
                            data.data.map((op) => (op.isSelect = false))
                            this.setState({
                                onlinePresenceList: data.data,
                            })
                            resolve(true)

                        }
                        this.setState({ isLoading: false })

                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                })
            // })
            // promise.then((result) => {
            //     if (result) {
            //         return true
            //     }
            // })
        })
    }
    // Search Country
    onCountrySearch(e) {
        const { countryList, tempCountryList } = this.state
        this.setState({ country: '' })
        if (e.target.value != '') {
            console.log("tempCountryList ++++----------->", tempCountryList)

            var searchCoutryList = tempCountryList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.setState({
                country: e.target.value,
                countryErr: '',
                tempCountryList: searchCoutryList,
                isDisplayCountryList: true
            })
        }
        else {
            this.setState({
                country: e.target.value,
                tempCountryList: countryList,
                isDisplayCountryList: false
            })
        }
    }
    // render Country
    renderCountryList() {
        const { tempCountryList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCountryList.length > 0 && tempCountryList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                country: data.Description, countryId: data.Code, isDisplayCountryList: false, preMobNo: `+${data.CountryCode}`, altPreMobNo: `+${data.CountryCode}`, PreMobileAuthorizedPerson: `+${data.CountryCode}`,
                            })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }
    // Search Country
    onCountrySearch2(e, i) {
        const { countryList2, tempCountryList2 } = this.state
        // this.setState({ country: '' })
        console.log(e.target.value, tempCountryList2)
        if (e.target.value != '') {
            console.log("tempCountryList ++++----------->", tempCountryList2)

            var searchCoutryList = tempCountryList2.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            console.log("searchCoutryList ++++----------->", searchCoutryList)

            this.enterCountry(e, i)
            this.setState({
                tempCountryList2: searchCoutryList,
            })
        }
        else {
            this.enterCountry(e, i)
            this.setState({
                tempCountryList2: countryList2,
            })
        }
    }
    // render Country
    renderCountryList2(i) {
        const { tempCountryList2, isDisplayCountryList2 } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCountryList2.length > 0 && tempCountryList2.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.selectCountry(data.Code, data.Description, i)}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }
    // search state
    onStateSearch(e) {
        const { tempStateList, stateList } = this.state
        if (e.target.value != '') {
            var searchStateList = tempStateList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                state: e.target.value,
                stateErr: '',
                tempStateList: searchStateList,
                isDisplayStateList: true
            })
        } else {
            this.setState({
                state: e.target.value,
                tempStateList: stateList,
                isDisplayStateList: false
            })
        }
    }
    // render state
    renderStateList() {
        const { tempStateList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempStateList.length > 0 && tempStateList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ state: data.Description, isDisplayStateList: false })}
                        // onClick={e => this.callStateList(data.Description)}
                        >{data.Description}</li>

                    ))
                }
            </ul>
        )
    }
    // search city
    onCitySearch(e) {
        const { cityList, tempCityList } = this.state
        if (e.target.value != '') {
            var searchCityList = tempCityList.filter(data => {
                return (
                    data
                        .Description
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                city: e.target.value,
                cityErr: '',
                tempCityList: searchCityList,
                isDisplayCityList: true
            })
        } else {
            this.setState({
                city: e.target.value,
                tempCityList: cityList,
                isDisplayCityList: false
            })
        }
    }
    // render city
    renderCityList() {
        const { tempCityList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempCityList.length > 0 && tempCityList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({ city: data.Description, isDisplayCityList: false })}
                        >{data.Description}</li>
                    ))
                }
            </ul>
        )
    }
    onPincodeSearch(e) {
        const { pincodeList, tempPincodeList, billCity } = this.state
        if (e.target.value != '') {
            var searchPincodeList = tempPincodeList.filter(x => {
                return (
                    x
                        .Pincode
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                Pin: e.target.value,
                PinErr: '',
                tempPincodeList: searchPincodeList,
                isDisplayPincodeList: true
            })
        } else {
            this.setState({
                Pin: e.target.value,
                tempPincodeList: pincodeList,
                isDisplayPincodeList: false
            })
        }
    }
    renderPincodeList() {
        const { tempPincodeList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempPincodeList.length > 0 && tempPincodeList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={e => this.setState({
                                Pin: data.Pincode,
                                isDisplayPincodeList: false
                            })}
                        >{data.Pincode}</li>
                    ))
                }
            </ul>
        )
    }
    OnAddList1(e) {
        e.preventDefault();
        const { list1 } = this.state
        var id = list1.length + 1
        var map = {
            Deliverable: '',
            Quantity: '',
            ScheduleDuration: '',
        }
        list1.push(map)
        this.setState({ list1: list1, })
        console.log(list1)
    }
    enterDelivables(e, index) {
        const { list1 } = this.state
        const list = [...list1]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Deliverable'] = e.target.value
            }
        }
        this.setState({
            list1: list
        })
    }
    enterQuantity(e, index) {
        const { list1 } = this.state
        const list = [...list1]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Quantity'] = e.target.value
            }
        }
        this.setState({
            list1: list
        })
    }
    enterSchedule(e, index) {
        const { list1 } = this.state
        const list = [...list1]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['ScheduleDuration'] = e.target.value
            }
        }
        this.setState({
            list1: list
        })
    }
    OnAddList2(e) {
        e.preventDefault();
        const { list2 } = this.state
        var id = list2.length + 1
        var map = {
            FirstName: '',
            LastName: '',
            Designation: '',
            Email: '',
            Mobile: '',
            country: '',
            CountryID: '',
            isDisplayCountryList2: false
        }
        list2.push(map)
        this.setState({ list2: list2, })
        console.log(list2)
    }
    enterFirstName(e, index) {
        const { list2 } = this.state
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['FirstName'] = e.target.value
            }
        }
        this.setState({
            list2: list
        })
    }
    enterLastName(e, index) {
        const { list2 } = this.state
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['LastName'] = e.target.value
            }
        }
        this.setState({
            list2: list
        })
    }
    enterDesignation(e, index) {
        const { list2 } = this.state
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Designation'] = e.target.value
            }
        }
        this.setState({
            list2: list
        })
    }
    enterEmail(e, index) {
        const { list2 } = this.state
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Email'] = e.target.value
            }
        }
        this.setState({
            list2: list
        })
    }
    enterCountry(e, index) {
        const { list2 } = this.state

        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['country'] = e.target.value
                if (e.target.value != '') {
                    list[i]['isDisplayCountryList2'] = true
                }
                else {
                    list[i]['isDisplayCountryList2'] = false
                }
            }
        }
        this.setState({
            list2: list
        })
    }
    selectCountry(value, name, index) {
        const { list2, countryList2 } = this.state
        console.log(value)
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['CountryID'] = value
                list[i]['country'] = name
                list[i]['isDisplayCountryList2'] = false
            }
        }
        this.setState({
            list2: list, tempCountryList2: countryList2
        })
    }
    enterMobileNo(e, index) {
        const { list2 } = this.state
        const list = [...list2]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Mobile'] = e.target.value
            }
        }
        this.setState({
            list2: list
        })
    }
    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }

    // on check level 4
    onSelectLevel4(e, id) {
        const { level4, exhibitDetailsList } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level4[i])) {
                        level4[i].isLengthValidate = false;
                        exhibitDetailsList.push(level4[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }
                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level4[i]['ChapterID']) })
                }

                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level4: level4, exhibitDetailsTableErr: '', isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' })
        }, 200);

        console.log('exhibitDetailsList : ', exhibitDetailsList);
    }

    // on check level 2
    onCheckLevel2(e, id) {
        const { level2, exhibitDetailsList, isDoubleStorey, doubleStoreyArea, schemeType, schemeTypeErr, stallAreaId, stallAreaIdErr, stallAreaList } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level2[i])) {
                        level2[i].isLengthValidate = false;
                        exhibitDetailsList.push(level2[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }

                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level2[i]['ChapterID']) })
                }

                level2[i]['IsSelect'] = !level2[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level2: level2, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' })
        }, 200);
    }

    // on check level 3
    onCheckLevel3(e, id) {
        const { level3, exhibitDetailsList } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!exhibitDetailsList.includes(level3[i])) {
                        level3[i].isLengthValidate = false;
                        exhibitDetailsList.push(level3[i])
                        this.setState({ exhibitDetailsList: exhibitDetailsList })
                    }
                }
                else {
                    this.setState({ exhibitDetailsList: exhibitDetailsList.filter(item => item.ChapterID != level3[i]['ChapterID']) })
                }

                level3[i]['IsSelect'] = !level3[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level3: level3, isDoubleStorey: false, doubleStoreyArea: '', doubleStoreyAreaErr: '', schemeType: '', schemeTypeErr: '', stallAreaId: '', stallAreaIdErr: '', stallAreaList: [], stallAreaName: '', area: '', InternationalArea: '' })
        }, 200);
    }

    // to call level third list 
    record(level2, level3, level4) {
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={'#collapse_l2_' + level3data.ChapterID} aria-expanded="false" aria-controls={'collapse_l2_' + level3data.ChapterID}>
                                                {/* // checkbox for level3 */}
                                                {
                                                    level3data.IsCheckbox && <input type="checkbox" className="from-left-sp"
                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID)} />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordFour(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    // to call level four list
    recordFour(level3data, level4) {
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">
                                {/* level4data.IsCheckbox && */}
                                <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID)} />
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }

    handleTotalCirculationSelect(e) {
        console.log("111111111111111111111", e)
        this.setState({ selectedTotalCirculation: e })
    }
    handleOverseasCirculationSelect(e) {
        console.log("111111111111111111111", e)
        this.setState({ selectedOverseasCirculation: e })
    }
    handleRegionsCoveredinIndiaSelect(e) {
        console.log("111111111111111111111", e)
        this.setState({ selectedRegionsCoveredinIndia: e })
    }
    onOnlinePresenceSelect(data, id) {
        const { onlinePresenceList } = this.state
        onlinePresenceList[id].isSelect = !onlinePresenceList[id].isSelect
        this.setState({ onlinePresenceList: onlinePresenceList })
    }


    onFilePick = async (e, file) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        this.setState({ logoImg: image, logoImgErr: '' })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ logoImg: image, logoImgErr: '' })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ logoImgType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });
    onCrossClick() {
        this.setState({ logoImg: "" })
        document.getElementById("path").value = ""
    }

    getPartnerDetails() {
        const { TandC, offerList } = this.state
        this.setState({ isLoading: true, })
        // this.setState({ TandC: [], offerList: [] })
        this.props.getPartnerApplicationDetails_action().then((data) => {
            if (data.error != 1) {
                // console.log(data.data, data.data.totalCircularList)
                if (data.data != undefined && data.data != null) {
                    var mainData = data.data.mainData[0]
                    var partnerDeliverableList = []
                    var partnerBearerList = []
                    var overseaslist = []
                    var regionList = []
                    var totalCirculationList = []
                    var selectChapterList = []
                    if (mainData != null && mainData != '' && mainData != undefined) {
                        // console.log("qq", mainData.Code)
                        var id = mainData.ExhRegistrationNo.replaceAll('/', '_')
                        this.setState({
                            exhno: id,
                            add1: mainData.Address1,
                            add2: mainData.Address2,
                            altMobNo: mainData.AlternateMobileNo,
                            city: mainData.City,
                            companyName: mainData.CompanyName,
                            countryId: mainData.CountryID,
                            designation: mainData.Designation,
                            fasciaName: mainData.FasciaName,
                            lastName: mainData.LastNamePersonIncharge,
                            ExhibitorCompanyName: mainData.ExhUndertakingCompanyName,
                            DesignationAuthorizedPerson: mainData.ExhUndertakingDesignation,
                            MobileAuthorizedPerson: mainData.ExhUndertakingMobileNo,
                            EmailAuthorizedPerson: mainData.ExhUndertakingEmail,
                            AuthorizedPersonName: mainData.ExhUndertakingPersonName,
                            totalCirculationNo: mainData.TotalCirculationNo,
                            mobNo: mainData.MobileNo,
                            firstName: mainData.PersonIncharge,
                            Pin: mainData.Pin,
                            primaryEmail: mainData.PrimaryEmail,
                            secondaryEmail: mainData.SecondaryEmail,
                            state: mainData.State,
                            telNo: mainData.Telephone,
                            title_PersonIncharge: mainData.Title_PersonIncharge,
                            website: mainData.Website,
                            formID: mainData.PartnerTypeID,
                            formName: mainData.PartnerTypeName,
                            ref: mainData.code,
                            isAgree: mainData.IsAgreePartner,
                            isAgreeConsent: mainData.isAgreeConsent
                        })
                        if (mainData.Logo != null && mainData.Logo != '') {
                            var filePath = mainData.Logo
                            var array = mainData.Logo != null &&
                                mainData.Logo != "" && filePath.split("/")
                            const FileName = array[array.length - 1]
                            this.setState({
                                logoFilePath: filePath,
                                logoImg: FileName,
                                isDocDeleted: false,
                            })
                        }
                        for (var i = 0; i < this.state.countryList.length; i++) {
                            if (mainData.CountryID == this.state.countryList[i].Code) {
                                this.setState({
                                    country: this.state.countryList[i].Description, isDisplayCountryList: false, preMobNo: `+${this.state.countryList[i].CountryCode}`,
                                    altPreMobNo: `+${this.state.countryList[i].CountryCode}`, PreMobileAuthorizedPerson: `+${this.state.countryList[i].CountryCode}`,
                                })
                            }
                        }


                    }

                    for (var i = 0; i < data.data.partnerDeliverableList.length; i++) {
                        var obj = {}
                        obj.Deliverable = data.data.partnerDeliverableList[i].Deliverable
                        obj.Quantity = data.data.partnerDeliverableList[i].Quantity
                        obj.ScheduleDuration = data.data.partnerDeliverableList[i].ScheduleDuration
                        partnerDeliverableList.push(obj)
                    }
                    this.setState({ list1: partnerDeliverableList })

                    for (var i = 0; i < data.data.partnerBearerList.length; i++) {
                        var obj = {}
                        obj.FirstName = data.data.partnerBearerList[i].FirstName
                        obj.LastName = data.data.partnerBearerList[i].LastName
                        obj.Designation = data.data.partnerBearerList[i].Designation
                        obj.Email = data.data.partnerBearerList[i].Email
                        obj.Mobile = data.data.partnerBearerList[i].Mobile
                        obj.CountryID = data.data.partnerBearerList[i].CountryID

                        obj.isDisplayCountryList2 = false
                        for (var j = 0; j < this.state.countryList.length; j++) {
                            if (data.data.partnerBearerList[i].CountryID == this.state.countryList[j].Code) {
                                obj.country = this.state.countryList[j].Description
                            }
                        }

                        partnerBearerList.push(obj)
                    }
                    this.setState({ list2: partnerBearerList })

                    for (var i = 0; i < data.data.chapterlist.length; i++) {
                        console.log(data.data.chapterlist[i].ChapterID)
                        for (var j = 0; j < this.state.primaryChapterListData.length; j++) {
                            if (data.data.chapterlist[i].ChapterID == this.state.primaryChapterListData[j].ChapterID) {
                                this.state.primaryChapterListData[j].IsSelect = true
                                selectChapterList.push(this.state.primaryChapterListData[j])
                            }
                        }
                        for (var j = 0; j < this.state.level0.length; j++) {
                            if (data.data.chapterlist[i].ChapterID == this.state.level0[j].ChapterID) {
                                this.state.level0[j].IsSelect = true
                                selectChapterList.push(this.state.level0[j])
                            }
                        }
                        for (var j = 0; j < this.state.level2.length; j++) {
                            if (data.data.chapterlist[i].ChapterID == this.state.level2[j].ChapterID) {
                                this.state.level2[j].IsSelect = true
                                selectChapterList.push(this.state.level2[j])
                            }
                        }
                        for (var j = 0; j < this.state.level3.length; j++) {
                            if (data.data.chapterlist[i].ChapterID == this.state.level3[j].ChapterID) {
                                this.state.level3[j].IsSelect = true
                                selectChapterList.push(this.state.level3[j])
                            }
                        }
                        for (var j = 0; j < this.state.level4.length; j++) {
                            if (data.data.chapterlist[i].ChapterID == this.state.level4[j].ChapterID) {
                                this.state.level4[j].IsSelect = true
                                selectChapterList.push(this.state.level4[j])
                            }
                        }
                    }
                    console.log(selectChapterList)
                    this.setState({ selectedChapterList: selectChapterList })
                    for (var i = 0; i < data.data.totalCircularList.length; i++) {
                        var obj = {}
                        obj.label = data.data.totalCircularList[i].CountryName
                        obj.value = data.data.totalCircularList[i].CountryID
                        totalCirculationList.push(obj)
                    }
                    this.setState({ selectedTotalCirculation: totalCirculationList })
                    for (var i = 0; i < data.data.OverseasCirculationList.length; i++) {
                        var obj = {}
                        obj.label = data.data.OverseasCirculationList[i].CountryName
                        obj.value = data.data.OverseasCirculationList[i].CountryID
                        overseaslist.push(obj)
                    }
                    this.setState({ selectedOverseasCirculation: overseaslist })
                    for (var i = 0; i < data.data.partnerRegionList.length; i++) {
                        var obj = {}
                        obj.label = data.data.partnerRegionList[i].State
                        obj.value = data.data.partnerRegionList[i].PartnerRegionID
                        regionList.push(obj)
                    }
                    this.setState({ selectedRegionsCoveredinIndia: regionList })
                    for (var i = 0; i < data.data.partnerOnlinePresenceList.length; i++) {
                        var obj = {}
                        for (var j = 0; j < this.state.onlinePresenceList.length; j++) {
                            if (this.state.onlinePresenceList[j].OnlinePresencePartnerID == data.data.partnerOnlinePresenceList[i].OnlinePresencePartnerID) {
                                this.state.onlinePresenceList[j].isSelect = true
                            }
                        }
                    }
                    this.setState({ onlinePresenceList: this.state.onlinePresenceList })
                    // console.log("qq", mainData.code[1])

                    this.props.getPartnerStaticData_action(JSON.parse(sessionStorage.getItem("sessionExhibitionID")), mainData.code)
                        .then((data) => {
                            if (data.error != 1) {
                                TandC.length = 0
                                offerList.length = 0
                                var tempofferList = []
                                var tempTandCList = []
                                for (var i = 0; i < data.data[0].length; i++) {
                                    if (data.data[0][i].IsOffer && (data.data[0][i].parent_id == 0 || data.data[0][i].parent_id == null)) {
                                        var obj = {}
                                        obj.Description = data.data[0][i].Description
                                        obj.Code = data.data[0][i].SeqNo
                                        tempofferList.push(obj)
                                    }
                                    if (data.data[0][i].IsTermAndCondition && (data.data[0][i].parent_id == 0 || data.data[0][i].parent_id == null)) {
                                        var obj = {}
                                        obj.Description = data.data[0][i].Description
                                        obj.Code = data.data[0][i].SeqNo
                                        tempTandCList.push(obj)
                                    }
                                }
                                console.log(tempTandCList, tempofferList)

                                for (var i = 0; i < tempofferList.length; i++) {
                                    var sub = []
                                    for (var j = 0; j < data.data[0].length; j++) {
                                        if (data.data[0][j].IsOffer && (tempofferList[i].Code == data.data[0][j].parent_id)) {
                                            var obj = {}
                                            obj.Description = data.data[0][j].Description
                                            obj.Code = data.data[0][j].SeqNo[data.data[0][j].SeqNo.length - 1]
                                            sub.push(obj)
                                        }
                                    }
                                    tempofferList[i].subdata = sub
                                }
                                for (var i = 0; i < tempTandCList.length; i++) {
                                    var sub = []
                                    for (var j = 0; j < data.data[0].length; j++) {
                                        if (data.data[0][j].IsTermAndCondition && (tempTandCList[i].Code == data.data[0][j].parent_id)) {

                                            var obj = {}
                                            obj.parent_id = tempTandCList[i].Code
                                            obj.Description = data.data[0][j].Description
                                            obj.Code = data.data[0][j].SeqNo[data.data[0][j].SeqNo.length - 1]
                                            sub.push(obj)
                                        }
                                    }
                                    tempTandCList[i].subdata = sub
                                }
                                var undertakingContent = []
                                data.data[1][0]['UndertakingContent1'] != null && data.data[1][0]['UndertakingContent1'] != undefined && undertakingContent.push(data.data[1][0]['UndertakingContent1'])
                                data.data[1][0]['UndertakingContent2'] != null && data.data[1][0]['UndertakingContent2'] != undefined && undertakingContent.push(data.data[1][0]['UndertakingContent2'])
                                // data.data[1][0]['UndertakingContent3'] != null && data.data[1][0]['UndertakingContent3'] != undefined && undertakingContent.push(data.data[1][0]['UndertakingContent3'])
                                data.data[1][0]['UndertakingContent5'] != null && data.data[1][0]['UndertakingContent5'] != undefined && undertakingContent.push(data.data[1][0]['UndertakingContent5'])
                                data.data[1][0]['UndertakingContent4'] != null && data.data[1][0]['UndertakingContent4'] != undefined && undertakingContent.push(data.data[1][0]['UndertakingContent4'])
                                console.log(tempTandCList, tempofferList)
                                this.setState({ TandC: tempTandCList, offerList: tempofferList, undertakingContent: undertakingContent, isLoading: false })
                            }
                        })
                }
                this.setState({ isLoading: false })
            }
            else {
                this.setState({ isPageValid: false })
                toastError(data.msg)
            }
            this.setState({ isLoading: false })
        })
            .catch((err) => {
                this.setState({ isPageValid: false })
                toastError('Something went wrong...')
                console.log(err)
            })

    }

    async PdfRender() {
        const { RandRpath } = this.state;
        // console.log("RandRpath--------------------------------------------->", RandRpath)
        if (!RandRpath) return;

        const container = this.pdfContainerRef.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        const url = `${BASE_URL.split("/api")[0]}${RandRpath}`;
        console.log("url--------------------------------------------->", url)
        try {
            const pdf = await pdfjsLib.getDocument(url).promise;
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }

    onSubmit() {
        const { isLoading, isDisplayCountryList, isDisplayStateList, isDisplayCityList, isDisplayPincodeList, exhibitionID, countryList, tempCountryList, stateList, tempStateList, cityList, tempCityList, pincodeList, tempPincodeList, list1, list2, primaryChapterListData, level0, level2, level3, level4, selectedTotalCirculation, totalCirculationList, overseasCirculationList, selectedOverseasCirculation, regionsCoveredinIndiaList, selectedRegionsCoveredinIndia, onlinePresenceList, firstName, lastName, designation, companyName, fasciaName, add1, add2, country, state, city, Pin, countryId, preMobNo, altPreMobNo, mobNo, altMobNo, telNo, preTelNo, primaryEmail, secondaryEmail, website, logoImg, logoImgType, countryErr, stateErr, cityErr, PinErr, firstNameErr, lastNameErr, designationErr, companyNameErr, mobNoErr, telNoErr, emailErr, add1Err, formID, formName, isAgree, isAgreeConsent, title_PersonIncharge, isOther_title_PersonIncharge, other_title_PersonIncharge, totalCirculationNo, AuthorizedPersonName,
            AuthorizedPersonNameErr,
            DesignationAuthorizedPerson,
            DesignationAuthorizedPersonErr,
            ExhibitorCompanyName,
            ExhibitorCompanyNameErr,
            EmailAuthorizedPerson,
            EmailAuthorizedPersonErr,
            MobileAuthorizedPerson,
            PreMobileAuthorizedPerson,
            MobileAuthorizedPersonErr, } = this.state

        //input validate
        var ERR
        var chapterList = []
        var onlineList = []
        var listEmailErr
        var PrimaryEmailErr = emailValidator(primaryEmail)
        var secondaryEmailErr = secondaryEmail != '' && secondaryEmail != null ? emailValidator(secondaryEmail) : ''
        for (var i = 0; i < list2.length; i++) {
            listEmailErr = emailValidator(list2[i].Email)
            console.log("oooo", listEmailErr)
            if (listEmailErr != '') {
                console.log("oooocccccc",)
                break
            }
        }
        ERR = this.inputValidate()
        var errMsg = false
        var mobvalidate = ''
        // if (countryId == 91) {
        mobvalidate = emailValidator(EmailAuthorizedPerson)
        emailValidator(EmailAuthorizedPerson) != '' && this.setState({ EmailAuthorizedPersonErr: emailValidator(EmailAuthorizedPerson) })
        errMsg = emailValidator(EmailAuthorizedPerson) != '' ? true : false
        if (AuthorizedPersonName == '' || AuthorizedPersonName == null) {
            this.setState({ AuthorizedPersonNameErr: 'Please enter Authorized Person Name' })
            errMsg = true
        }
        if (MobileAuthorizedPerson == '' || MobileAuthorizedPerson == null) {
            this.setState({ MobileAuthorizedPersonErr: 'Please enter Authorized Person Mobile' })
            errMsg = true
        }
        if (EmailAuthorizedPerson == '' || EmailAuthorizedPerson == null) {
            this.setState({ EmailAuthorizedPersonErr: 'Please enter Authorized Person Email' })
            errMsg = true
        }
        if (DesignationAuthorizedPerson == '' || DesignationAuthorizedPerson == null) {
            this.setState({ DesignationAuthorizedPersonErr: 'Please enter Authorized Person Designation' })
            errMsg = true
        }
        if (ExhibitorCompanyName == '' || ExhibitorCompanyName == null) {
            this.setState({ ExhibitorCompanyNameErr: 'Please enter Exhibitor Company Name' })
            errMsg = true
        }
        if (errMsg) {
            toastError("Please fill mandatory fields")
            return
        }
        if (formID == 3) {
            for (var i = 0; i < primaryChapterListData.length; i++) {
                if (primaryChapterListData[i].IsSelect) {
                    chapterList.push(primaryChapterListData[i])
                }
            }
            for (var i = 0; i < level0.length; i++) {
                if (level0[i].IsSelect) {
                    chapterList.push(level0[i])
                }
            }
            for (var i = 0; i < level2.length; i++) {
                if (level2[i].IsSelect) {
                    chapterList.push(level2[i])
                }
            }
            for (var i = 0; i < level3.length; i++) {
                if (level3[i].IsSelect) {
                    chapterList.push(level3[i])
                }
            }
            for (var i = 0; i < level4.length; i++) {
                if (level4[i].IsSelect) {
                    chapterList.push(level4[i])
                }
            }
            if (chapterList.length == 0) {
                ERR = 'Please select atleast 1 industry Segment'
            }
            for (var i = 0; i < onlinePresenceList.length; i++) {
                if (onlinePresenceList[i].isSelect) {
                    onlineList.push(onlinePresenceList[i])
                }
            }
        }
        if (country != '' && country != null && state != '' && state != null && city != '' && city != null && Pin != '' && Pin != null && firstName != '' && firstName != null && lastName != '' && lastName != null && designation != '' && designation != null && designation != '' && designation != null && mobNo != '' && mobNo != null && primaryEmail != '' && primaryEmail != null && add1 != '' && add1 != null) {
            if (ERR == null) {

                if ((PrimaryEmailErr != '') || (secondaryEmailErr != '') || (listEmailErr != '')) {
                    toastError(
                        PrimaryEmailErr != '' ? PrimaryEmailErr : secondaryEmailErr != '' ? secondaryEmailErr : listEmailErr != '' ? listEmailErr : '')

                }
                else {


                    this.setState({ isLoading: true })
                    this.props.updatePartnerApplication_action(
                        formID,
                        isOther_title_PersonIncharge == true ? other_title_PersonIncharge : title_PersonIncharge,
                        firstName,
                        lastName,
                        designation,
                        companyName,
                        fasciaName,
                        add1,
                        add2,
                        Pin,
                        city,
                        state,
                        countryId,
                        mobNo,
                        altMobNo,
                        telNo,
                        primaryEmail,
                        secondaryEmail,
                        website,
                        null,
                        isAgree,
                        list1,
                        list2,
                        selectedRegionsCoveredinIndia,
                        selectedTotalCirculation,
                        selectedOverseasCirculation,
                        onlineList,
                        chapterList,
                        logoImg,
                        logoImgType, this.state.exhno, totalCirculationNo, isAgreeConsent,
                        AuthorizedPersonName,
                        DesignationAuthorizedPerson,
                        ExhibitorCompanyName,
                        EmailAuthorizedPerson,
                        MobileAuthorizedPerson,
                    ).then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false })
                            setTimeout(() => {

                                this.getPartnerDetails()
                                toastSuccess("updated successfully")
                            }, 200);

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
            else {
                toastError(ERR)
            }
        }
        else {
            toastError("Please fill all the mandatory fields")
        }

        console.log(list1, list2, chapterList, selectedTotalCirculation, selectedOverseasCirculation, selectedRegionsCoveredinIndia, onlinePresenceList, formID,
            firstName,
            lastName,
            designation,
            companyName,
            fasciaName,
            add1,
            add2,
            Pin,
            city,
            state,
            countryId,
            mobNo,
            altMobNo,
            telNo,
            primaryEmail,
            secondaryEmail,
            website,)
        console.log(ERR)
    }
    //Input Field Validations
    inputValidate() {
        const { firstName, lastName, designation, companyName, add1, state, Pin, city, countryId, mobNo, telNo, list1, list2, formID, onlinePresenceList, selectedOverseasCirculation, selectedRegionsCoveredinIndia, primaryEmail, selectedTotalCirculation } = this.state
        var ERR = null
        if (firstName == "") {
            this.setState({ firstNameErr: "Please enter Person Incharge" });
        }
        if (lastName == "") {
            this.setState({ lastNameErr: "Please enter Last name" });
        }
        if (designation == "") {
            this.setState({ designationErr: "Please Enter Designation" });
        }
        if (companyName == "") {
            this.setState({ companyNameErr: "Please Enter Company Name" });
        }
        if (add1 == "") {
            this.setState({ add1Err: "Please enter address" });
        }
        if (Pin == "") {
            this.setState({ PinErr: "Please Enter Zipcode" });
        }
        if (city == "") {
            this.setState({ cityErr: "Please Enter city" });
        }
        if (countryId == "91" && state == "") {
            this.setState({ stateErr: "Please Enter State" });
        }
        if (countryId == "") {
            this.setState({ countryErr: "Please Enter country" });
        }
        if (mobNo == "") {
            this.setState({ mobNoErr: "Please Enter Mobile No." });
        }
        if (primaryEmail == "") {
            this.setState({ emailErr: "Please Enter Primary Email" });
        }
        if (list2.length == 0) {
            ERR = 'Please add atleast 1 Partner Bearer'
        }
        if (list2 != 0) {
            for (var i = 0; i < list2.length; i++) {
                if (list2[i].FirstName == '' || list2[i].LastName == '' || list2[i].Designation == '' || list2[i].Email == '' || list2[i].Mobile == '' || list2[i].CountryID == '') {
                    ERR = 'Please fill all the  Partner Bearer columns'
                }
            }
        }
        if (list1.length == 0) {
            ERR = 'Please add atleast 1 Partner Deliverable'
        }
        if (list1 != 0) {
            for (var i = 0; i < list1.length; i++) {
                if (list1[i].Deliverable == '' || list1[i].Quantity == '' || list1[i].ScheduleDuration == '') {
                    ERR = 'Please fill all the  Partner Deliverable columns'
                }
            }
        }
        if (formID == 3) {
            if (onlinePresenceList.length != 0) {
                var onErr = false
                for (var i = 0; i < onlinePresenceList.length; i++) {
                    if (onlinePresenceList[i].isSelect == true) {
                        onErr = false
                        break
                    }
                    else {
                        onErr = true
                    }
                }
                if (onErr) {
                    ERR = 'Please select atleast 1 online presence'
                }
            }
            if (selectedRegionsCoveredinIndia.length == 0) {
                ERR = 'Please select atleast 1 Region covered in India'
            }
            if (selectedOverseasCirculation.length == 0) {
                ERR = 'Please select atleast 1 Overseas circulation'
            }
            // if (selectedTotalCirculation.length == 0) {
            //     ERR = 'Please select atleast 1 Total circulation'
            // }
            if (this.state.totalCirculationNo.length == '' || this.state.totalCirculationNo.length == null) {
                ERR = 'Please enter total Circulation No'
            }
        }
        return ERR
    }

    onChapterRemove(id, level) {
        const { primaryChapterListData, level0, level2, level3, level4, selectedChapterList } = this.state
        var promise = new Promise((resolve, rej) => {
            if (level == 1) {
                for (var i = 0; i < primaryChapterListData.length; i++) {
                    if (primaryChapterListData[i].ChapterID == id) {
                        primaryChapterListData[i].IsSelect = false
                    }
                }
            }
            if (level == 0) {
                for (var i = 0; i < level0.length; i++) {
                    if (level0[i].ChapterID == id) {
                        level0[i].IsSelect = false
                    }
                }
            }
            if (level == 2) {
                for (var i = 0; i < level2.length; i++) {
                    if (level2[i].ChapterID == id) {
                        level2[i].IsSelect = false
                    }
                }
            }
            if (level == 3) {
                for (var i = 0; i < level3.length; i++) {
                    if (level3[i].ChapterID == id) {
                        level3[i].IsSelect = false
                    }
                }
            }
            if (level == 4) {
                for (var i = 0; i < level4.length; i++) {
                    if (level4[i].ChapterID == id) {
                        level4[i].IsSelect = false
                    }
                }
            }
            for (var i = 0; i < selectedChapterList.length; i++) {
                if (selectedChapterList[i].ChapterID == id) {
                    selectedChapterList.splice(i, 1)
                }
            }
            resolve(true)

        })
        promise.then((result) => {
            if (result) {
                this.setState({
                    selectedChapterList: selectedChapterList,
                    primaryChapterListData: primaryChapterListData,
                    level0: level0,
                    level2: level2,
                    level3: level3,
                    level4: level4
                })

            }
        })
    }

    onDocDelete() {
        const { isDelOpen } = this.state
        this.setState({ isDelOpen: !isDelOpen })
    }

    // Delete Passport Document Delete
    handleDelete(e) {
        e.preventDefault()
        const { isDelOpen, logoImg } = this.state
        this.setState({ isLoading: true })
        this.props.partnerDeleteDoc_action()
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess(" Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isDelOpen: !isDelOpen, logoImg: "", isDocDeleted: true })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    render() {
        const { isLoading, level0, level2, level3, level4,
            isDisplayCountryList,
            isDisplayStateList,
            isDisplayCityList,
            isDisplayPincodeList,
            totalCirculationNo,
            exhibitionID, isDelOpen,
            countryList,
            tempCountryList, openPop4,
            stateList,
            tempStateList,
            cityList,
            tempCityList,
            pincodeList,
            tempPincodeList,
            list1,
            list2,

            primaryChapterListData,
            selectedTotalCirculation,
            totalCirculationList,
            overseasCirculationList,
            selectedOverseasCirculation,
            regionsCoveredinIndiaList,
            selectedRegionsCoveredinIndia,
            onlinePresenceList,
            AuthorizedPersonName,
            AuthorizedPersonNameErr,
            DesignationAuthorizedPerson,
            DesignationAuthorizedPersonErr,
            ExhibitorCompanyName,
            ExhibitorCompanyNameErr,
            EmailAuthorizedPerson,
            EmailAuthorizedPersonErr,
            MobileAuthorizedPerson,
            PreMobileAuthorizedPerson,
            MobileAuthorizedPersonErr,
            firstName,
            lastName,
            designation,
            companyName,
            fasciaName,
            add1,
            add2,
            country,
            state,
            city,
            Pin,
            countryId,
            preMobNo,
            altPreMobNo,
            mobNo,
            altMobNo,
            telNo,
            preTelNo,
            primaryEmail,
            secondaryEmail,
            website,

            logoImg,
            logoImgErr,
            logoImgType,

            //err
            countryErr,
            stateErr,
            cityErr,
            PinErr,
            firstNameErr,
            lastNameErr,
            designationErr,
            companyNameErr,
            mobNoErr, isOpenConfirmationModal,
            telNoErr, add1Err, emailErr,

            formID, isDisplayCountryList2, formName, } = this.state
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        return (<>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
            <ToastContainer />
            <ExhibitorHeader />
            <ExhibitorDrawer />
            {/*app-content open*/}
            <div className="page">
                <div className="page-main">
                    <div className="main-content with-dr-container exb-top-sapce">
                        {/* <div className="container-fluid">
                                <div className="row">
                                    <div className="tab-scroll-fixed">
                                <p>Exhibitor Dashboard</p>
                            </div>
                                    <ExhibitorTopMenu />
                                </div>
                            </div> */}
                        <div className=" width-dr-nav">
                            <div className="row">
                                <ExhibitorTopMenu />
                            </div>
                        </div>
                        <div className="exb-top-space" >
                            <div className="card-header p-2 " >
                                <h3 className="card-title">Partner Registration Summary
                                </h3>
                            </div>
                            <div className="main-container container-fluid p-2">
                                <div className="side-app">
                                    <div className="col-xl-12 p-0">
                                        <div className="card rounded-0">
                                            {/* <div className="card-body p-0">
                                                <h6 className="" style={{ padding: "5px 7px 3px 0px" }}>
                                                    Dear {JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['CompanyName'] != null &&
                                                        JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['CompanyName']}
                                                </h6>
                                            </div> */}
                                            <div className=" mt-3">
                                                <div className="form-row m-0">
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Person in charge(First Name)<span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            this.state.isOther_title_PersonIncharge &&
                                                            <input
                                                                type="text"
                                                                className="form-control-1 other-fil"
                                                                value={this.state.other_title_PersonIncharge}
                                                                onChange={e => this.setState({ other_title_PersonIncharge: e.target.value })}

                                                                placeholder={'Other'}
                                                                style={{

                                                                    // position: "absolute",

                                                                    paddingLeft: '5px'
                                                                }}
                                                            />
                                                        }

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={100}
                                                            required=""
                                                            style={{ position: "relative", paddingLeft: '55px' }}
                                                            value={firstName}

                                                            onChange={e => this.setState({ firstName: e.target.value, firstNameErr: '' })}
                                                        />
                                                        <div className="col-xl-1 mb-3">
                                                            <div
                                                                className="form-group"
                                                                value={this.state.title_PersonIncharge}
                                                                onChange={e => this.setState({ title_PersonIncharge: e.target.value })}

                                                                style={{
                                                                    width: '45px',
                                                                    position: "absolute",
                                                                    top: "-59px",
                                                                    left: '0px'
                                                                }}
                                                            >
                                                                <label />
                                                                <select
                                                                    className="form-control-1 select2 select-hidden-accessible"
                                                                    id="roledb"
                                                                    style={{
                                                                        paddingLeft: '0px',
                                                                        paddingRight: '0px',
                                                                        borderTop: "none",
                                                                        borderBottom: "none",
                                                                        marginTop: '0px',
                                                                        textAlign: "left"
                                                                    }}
                                                                    value={this.state.title_PersonIncharge}

                                                                    onChange={e => this.setState({
                                                                        title_PersonIncharge: e.target.value,
                                                                        isOther_title_PersonIncharge: e.target.value == "Other" && true
                                                                    })}


                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{firstNameErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Last Name<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={lastName}
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ lastName: e.target.value, lastNameErr: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{lastNameErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Designation<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={designation}
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ designation: e.target.value, designationErr: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{designationErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Company Name<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={companyName}
                                                            disabled
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ companyName: e.target.value, companyNameErr: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{companyNameErr}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="form-row m-0">
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Fascia Name (Shell Scheme only) <span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={fasciaName}
                                                            disabled
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ fasciaName: e.target.value, })}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Address line 1<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={add1}
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ add1: e.target.value, add1Err: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{add1Err}</span>}

                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Address line 2
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={add2}
                                                            // maxLength={500}
                                                            onChange={e => this.setState({ add2: e.target.value, })}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Pincode<span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            countryId == "91" &&
                                                            <input
                                                                type="text"
                                                                maxLength={6}
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                disabled
                                                                value={Pin}
                                                                onChange={(e) => this.onPincodeSearch(e)}
                                                            />
                                                        }
                                                        {
                                                            countryId != "91" &&
                                                            <input
                                                                type="number"
                                                                maxLength={10}
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                disabled
                                                                value={Pin}
                                                                // disabled={is_view || isSameAsCorrespondence}
                                                                onChange={(e) => this.onPincodeSearch(e)}
                                                            // onInput={toInputUppercase}
                                                            />
                                                        }
                                                        {isDisplayPincodeList && this.renderPincodeList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{PinErr}</span>}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="form-row m-0">
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            City<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled
                                                            // disabled={is_view}
                                                            value={city}
                                                            onChange={(e) => this.onCitySearch(e)}
                                                        />
                                                        {isDisplayCityList && this.renderCityList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{cityErr}</span>}

                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            {countryId == "91" ? "State" : "State/Province"}
                                                            {countryId == "91" && <span className="text-red">*</span>}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            // disabled={is_view}
                                                            disabled
                                                            value={state}
                                                            onChange={(e) => this.onStateSearch(e)}
                                                        />
                                                        {isDisplayStateList && this.renderStateList()}
                                                        {countryId == "91" && <span className='text-danger text-start text-left d-block mt-1'>{stateErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Country<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            disabled
                                                            id="validationCustom03"
                                                            // disabled={is_view || is_update}
                                                            value={country}
                                                            onChange={(e) => this.onCountrySearch(e)}
                                                        />
                                                        {isDisplayCountryList && this.renderCountryList()}
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{countryErr}</span>}
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Mobile No. 1<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="number"

                                                            className="form-control"
                                                            value={mobNo}
                                                            maxLength={sessionStorage.getItem('countryId') === "43" ? 11 : 10}
                                                            onInput={e => this.maxLengthCheck(e, 10)}
                                                            onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyPress={e => this.preventMinus(e)}
                                                            onChange={e => this.setState({ mobNo: e.target.value, mobNoErr: '' })}
                                                            style={{ paddingLeft: '50px' }} />
                                                        <input
                                                            type="text"
                                                            placeholder="ISD"
                                                            className="form-control-1"
                                                            value={preMobNo}
                                                            onChange={e => this.setState({ preMobNo: e.target.value })}
                                                            style={{
                                                                width: '45px',
                                                                position: "absolute",
                                                                top: '23px',
                                                                paddingLeft: '5px'
                                                            }}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{mobNoErr}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="form-row m-0">
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Mobile No. 2
                                                        </label>
                                                        <input
                                                            type="number"

                                                            className="form-control"
                                                            value={altMobNo}
                                                            maxLength={sessionStorage.getItem('countryId') === "43" ? 11 : 10}
                                                            onInput={e => this.maxLengthCheck(e, 10)}
                                                            onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyPress={e => this.preventMinus(e)}
                                                            onChange={e => this.setState({ altMobNo: e.target.value, })}
                                                            style={{ paddingLeft: '50px' }} />
                                                        <input
                                                            type="text"
                                                            placeholder="ISD"
                                                            className="form-control-1"
                                                            value={altPreMobNo}
                                                            onChange={e => this.setState({ altPreMobNo: e.target.value })}
                                                            style={{
                                                                width: '45px',
                                                                position: "absolute",
                                                                top: '23px',
                                                                paddingLeft: '5px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Telephone no.
                                                        </label>
                                                        <input
                                                            type="number"

                                                            className="form-control"
                                                            value={telNo}
                                                            maxLength={sessionStorage.getItem('countryId') === "43" ? 11 : 10}
                                                            onInput={e => this.maxLengthCheck(e, 10)}
                                                            onKeyDown={e => (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()}
                                                            onWheel={(e) => e.target.blur()}
                                                            onKeyPress={e => this.preventMinus(e)}
                                                            onChange={e => this.setState({ telNo: e.target.value, })}
                                                            style={{ paddingLeft: '50px' }} />
                                                        <input
                                                            type="text"
                                                            placeholder="ISD"
                                                            className="form-control-1"
                                                            value={preTelNo}
                                                            onChange={e => this.setState({ preTelNo: e.target.value, })}
                                                            style={{
                                                                width: '45px',
                                                                position: "absolute",
                                                                top: '23px',
                                                                paddingLeft: '5px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Primary Email<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            disabled
                                                            value={primaryEmail}
                                                            maxLength={500}
                                                            onChange={e => this.setState({ primaryEmail: e.target.value, emailErr: '' })}
                                                        />
                                                        {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>}

                                                    </div>
                                                    <div className="col-xl-3 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Secondary Email
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={secondaryEmail}
                                                            maxLength={500}
                                                            onChange={e => this.setState({ secondaryEmail: e.target.value, })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="form-row m-0">
                                                    <div className="col-xl-6 mb-1">
                                                        <label htmlFor="validationCustom03">
                                                            Website
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            required=""
                                                            value={website}
                                                            maxLength={500}
                                                            onChange={e => this.setState({ website: e.target.value, })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                formID == 3 &&
                                                <div className="row">
                                                    <div className="col-lg-12 col-md-12 mt-4">
                                                        <div className="asc" style={{ border: "1px solid #ddd" }}>
                                                            <div
                                                                className="card-header p-2 mb-2"
                                                                style={{ padding: "9px!important" }}
                                                            >
                                                                <h3 className="card-title" style={{ fontSize: 14 }}>
                                                                    Select Industry Segment<span className="text-red">*</span>
                                                                </h3>
                                                            </div>
                                                            <div className="" style={{ paddingLeft: 10 }}>
                                                                <form className="needs-validation pb-2" noValidate="">
                                                                    <div className="form-row m-0">
                                                                        <div class="accordion" id="accordionExample">
                                                                            {
                                                                                level2.length > 0 && level2.map(level2Data => (
                                                                                    <>
                                                                                        {
                                                                                            // level2Data.ParentChapterID == primaryChapterRadio &&
                                                                                            <div class="accordion-item">
                                                                                                <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                                                    <button class={level2Data.isHighlight ? "accordion-button collapsed selected-chapter" : "accordion-button collapsed"}
                                                                                                        type="button" data-bs-toggle="collapse"
                                                                                                        data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                                                        aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                                                        {/* // checkbox for level2 */}
                                                                                                        {
                                                                                                            level2Data.IsCheckbox &&
                                                                                                            <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                                                checked={level2Data.IsSelect}
                                                                                                                onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)} />
                                                                                                        }
                                                                                                        {level2Data.ChapterName} </button>
                                                                                                </h2>
                                                                                                {this.record(level2Data, level3, level4)}
                                                                                            </div>
                                                                                        }

                                                                                    </>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>

                                                            {this.state.selectedChapterList.length > 0 &&
                                                                <div className="col-md-8 pl-0">
                                                                    <div className="table-responsive mx-2">
                                                                        <table class="table border text-nowrap text-md-nowrap table-bordered mt-1">
                                                                            <thead>
                                                                                <tr>
                                                                                    {/* <th className="text-center" style={{ width: '60px' }}><strong>Sr no.</strong></th> */}
                                                                                    <th className="fw-semibold">Selected Segment</th>
                                                                                    <th className="text-center"><strong></strong></th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {this.state.selectedChapterList.map(element => (
                                                                                    <tr key={Math.random()}>
                                                                                        {/* <th className="text-center" style={{ width: '60px' }}>{data.}</th> */}
                                                                                        <td>{element.ChapterName}</td>
                                                                                        <td className="text-center">
                                                                                            <i class="fa fa-trash grid-icon" aria-hidden="true"
                                                                                                onClick={(e) => this.onChapterRemove(element.ChapterID, element.Level)}
                                                                                            ></i></td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                formID == 3
                                                &&
                                                <div className="row">
                                                    <div className="col-lg-12 card-header mt-2">
                                                        <div
                                                            className="card-title col-md-3 p-1 mb-2"
                                                            style={{ padding: "9px!important" }}
                                                        >
                                                            <h3 className="" style={{ fontSize: 14 }}>
                                                                Total Circulation<span className="text-red">*</span>:
                                                            </h3>
                                                            {/* <Select
                                                            options={totalCirculationList.map((option) => ({ label: option.Description, value: option.Code }))}
                                                            value={selectedTotalCirculation}
                                                            onChange={this.handleTotalCirculationSelect}
                                                            isMulti
                                                        /> */}
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id="validationCustom03"
                                                                required=""
                                                                value={totalCirculationNo}
                                                                maxLength={500}
                                                                onChange={e => this.setState({ totalCirculationNo: e.target.value, })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>}
                                            {
                                                formID == 3
                                                &&
                                                <div className="row">
                                                    <div className="col-lg-12 card-header mt-2">
                                                        <div
                                                            className="card-title col-md-6 p-1 mb-2"
                                                            style={{ padding: "9px!important" }}
                                                        >
                                                            <h3 className="" style={{ fontSize: 14 }}>
                                                                Overseas Circulation<span className="text-red">*</span>:
                                                            </h3>
                                                            <Select
                                                                options={overseasCirculationList.map((option) => ({ label: option.Description, value: option.Code }))}
                                                                value={selectedOverseasCirculation}
                                                                onChange={this.handleOverseasCirculationSelect}
                                                                isMulti
                                                            />
                                                        </div>
                                                    </div>
                                                </div>}
                                            {
                                                formID == 3 &&
                                                <div className="row">
                                                    <div className="col-lg-12 card-header mt-2">
                                                        <div
                                                            className="card-title col-md-6 p-1 mb-2"
                                                            style={{ padding: "9px!important" }}
                                                        >
                                                            <h3 className="" style={{ fontSize: 14 }}>
                                                                Region Covered in India<span className="text-red">*</span>:
                                                            </h3>
                                                            <Select
                                                                options={regionsCoveredinIndiaList.map((option) => ({ label: option.Description, value: option.Code }))}
                                                                value={selectedRegionsCoveredinIndia}
                                                                onChange={this.handleRegionsCoveredinIndiaSelect}
                                                                isMulti
                                                            />
                                                        </div>
                                                    </div>
                                                </div>}
                                            {
                                                formID == 3 &&
                                                <div className="row">
                                                    <div className="col-lg-12 card-header mt-4">
                                                        <div
                                                            className="card-title col-md-6 p-2 mb-2"
                                                            style={{ padding: "9px!important" }}
                                                        >
                                                            <h3 className="" style={{ fontSize: 14 }}>
                                                                Online Presence<span className="text-red">*</span>:
                                                            </h3>

                                                            {onlinePresenceList.map((data, i) => (

                                                                <form>
                                                                    <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                                                                        <input type="checkbox"
                                                                            checked={data.isSelect}
                                                                            onChange={(e) => this.onOnlinePresenceSelect(data, i)}
                                                                        />
                                                                        {data.Name} </label>
                                                                </form>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>}


                                            <div className="form-row mt-3 m-0">
                                                <div className="col-xl-3 mb-1">
                                                    <label htmlFor="validationCustom03">
                                                        Upload logo
                                                    </label>
                                                    <div className="box">
                                                        <div className="js--image-preview col-xl-6" />
                                                        {this.state.isDocDeleted == false ?
                                                            <div style={{
                                                                border: '1px solid #ccc',
                                                                padding: '10px',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                // marginTop: '10px'
                                                            }}>
                                                                <a
                                                                    href={this.state.logoFilePath}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <span style={{ marginRight: '10px' }}
                                                                    >{logoImg}</span>
                                                                </a>
                                                                <i className={`fa fa-times text-danger img-can`}
                                                                    onClick={(e) => this.onDocDelete()}
                                                                ></i>
                                                            </div> :
                                                            <div className="upload-options mt-1">
                                                                <label>
                                                                    <input
                                                                        type="file"
                                                                        id="path"
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png, .pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files)}
                                                                    // disabled={isView}
                                                                    />
                                                                    <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                                        Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                                    </span>
                                                                    {
                                                                        logoImg != "" && logoImg != null &&
                                                                        <i class="fa fa-times text-danger img-can"
                                                                            onClick={() => this.onCrossClick()}
                                                                        ></i>
                                                                    }
                                                                </label>

                                                            </div>}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body mt-3 p-0">
                                                <div className="form-row m-0">
                                                    <p className='m-0 p-0 fw-semibold'>Kindly fill agreed offer from {formName}<span className="text-red">*</span></p>
                                                </div>
                                                <div class="table-responsive">
                                                    <table class="table border text-nowrap text-md-nowrap table-bordered mt-1">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-center fw-semibold">Deliverables<span className="text-red">*</span></th>
                                                                <th className="text-center fw-semibold">Quantity<span className="text-red">*</span></th>
                                                                <th className="text-center fw-semibold">Schedule / Duration<span className="text-red">*</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {list1.length > 0 && list1.map((data, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <input type="text" class="form-control"
                                                                            value={data.Deliverable}
                                                                            onChange={(e) => this.enterDelivables(e, i)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" class="form-control"
                                                                            value={data.Quantity}
                                                                            onChange={(e) => this.enterQuantity(e, i)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" class="form-control"
                                                                            value={data.ScheduleDuration}
                                                                            onChange={(e) => this.enterSchedule(e, i)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <button type="button" class="btn btn-aqua rounded-1 mt-0" style={{ float: 'right' }}
                                                        onClick={(e) => this.OnAddList1(e)}
                                                    >
                                                        Add row
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {this.state.offerList.length > 0 && <div className="mt-1 ms-0">
                                            <div className="card-body px-0 py-1">
                                                <p className='fw-semibold'> As {formName}, India ITME Society will offer your organization the following:</p>
                                            </div>
                                            <div className="card-body mx-2 p-0">
                                                {this.state.offerList.length > 0 && this.state.offerList.map((data, i) => (
                                                    <div>
                                                        <p> {data.Code}) {data.Description}</p>
                                                        {data.subdata.length > 0 && data.subdata.map((element, i) => (
                                                            <p className=' ms-4 mt-n1'> {element.Code}) {element.Description}</p>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>}
                                        <div className="card-body p-0 mx-2">
                                            <div className="form-row m-0">
                                                <p className='fw-semibold m-0 p-0'>Office Bearers details for Invitation<span className="text-red">*</span></p>
                                            </div>
                                            <div class="table-responsive">
                                                <table class="table border text-nowrap text-md-nowrap table-bordered mb-2">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">First Name<span className="text-red">*</span></th>
                                                            <th className="text-center">Last Name<span className="text-red">*</span></th>
                                                            <th className="text-center">Designation<span className="text-red">*</span></th>
                                                            <th className="text-center">Email<span className="text-red">*</span></th>
                                                            <th className="text-center">Mobile No<span className="text-red">*</span></th>
                                                            <th className="text-center">Country<span className="text-red">*</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list2.length > 0 && list2.map((data, i) => (
                                                            <tr key={data}>
                                                                <td>
                                                                    <input type="text" class="form-control"
                                                                        value={data.FirstName}
                                                                        onChange={(e) => this.enterFirstName(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input type="text" class="form-control"
                                                                        value={data.LastName}
                                                                        onChange={(e) => this.enterLastName(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input type="text" class="form-control"
                                                                        value={data.Designation}
                                                                        onChange={(e) => this.enterDesignation(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input type="text" class="form-control"
                                                                        value={data.Email}
                                                                        onChange={(e) => this.enterEmail(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input type="number" class="form-control"
                                                                        value={data.Mobile}
                                                                        onChange={(e) => this.enterMobileNo(e, i)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="validationCustom03"
                                                                        // disabled={is_view || is_update}
                                                                        value={data.country}
                                                                        onChange={(e) => this.onCountrySearch2(e, i)}
                                                                    />
                                                                    {data.isDisplayCountryList2 && this.renderCountryList2(i)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <button type="button" class="btn btn-aqua rounded-1 mt-1 mb-2" style={{ float: 'right' }}
                                                    onClick={(e) => this.OnAddList2(e)}
                                                >
                                                    Add row
                                                </button>
                                            </div>
                                        </div>
                                        {this.state.undertakingContent.length > 0 && <div>
                                            <div className="">
                                                <div className="card-body py-1">
                                                    <h6 className='mb-3'><strong>Exhibitor Undertaking for {sessionStorage.getItem("sessionExhibitionName")}</strong></h6>
                                                    {this.state.undertakingContent.map((data) => (
                                                        <p className='m-1 p-0'>{data}</p>
                                                    ))}
                                                </div>
                                                <div className="card-body py-1">
                                                    <div className="row mt-2">
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Authorized Person Name<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={AuthorizedPersonName}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        AuthorizedPersonName: e.target.value,
                                                                        AuthorizedPersonNameErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {AuthorizedPersonNameErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Designation of the Authorized person<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={DesignationAuthorizedPerson}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        DesignationAuthorizedPerson: e.target.value,
                                                                        DesignationAuthorizedPersonErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {DesignationAuthorizedPersonErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Exhibitor company Name<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={ExhibitorCompanyName}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        ExhibitorCompanyName: e.target.value,
                                                                        ExhibitorCompanyNameErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {ExhibitorCompanyNameErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <label htmlFor="validationCustom01">
                                                                Email of the Authorized person<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                maxLength={100}
                                                                className="form-control"
                                                                value={EmailAuthorizedPerson}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        EmailAuthorizedPerson: e.target.value,
                                                                        EmailAuthorizedPersonErr: "",
                                                                    })
                                                                }
                                                            />
                                                            {
                                                                <span className="text-danger text-start text-left d-block mt-1">
                                                                    {EmailAuthorizedPersonErr}
                                                                </span>
                                                            }
                                                        </div>
                                                        <div className="col-xl-4 mb-1">
                                                            <div
                                                                // className="col-xl-3 mb-1"
                                                                style={{ position: "relative" }}
                                                            >
                                                                <label htmlFor="validationCustom01">
                                                                    Mobile No. of the Authorized person<span className="text-red">*</span>
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    maxLength={
                                                                        sessionStorage.getItem("countryId") === "43"
                                                                            ? 11
                                                                            : 10
                                                                    }
                                                                    value={MobileAuthorizedPerson}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            MobileAuthorizedPerson: e.target.value,
                                                                            MobileAuthorizedPersonErr: "",
                                                                        })
                                                                    }
                                                                    onInput={(e) => sessionStorage.getItem("countryId") == 91 ? this.maxLengthCheck(e, 10) : null}
                                                                    size={"10"}
                                                                    onKeyDown={(e) =>
                                                                        (e.keyCode === 69 || e.keyCode === 190) &&
                                                                        e.preventDefault()
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                    onKeyPress={(e) => this.preventMinus(e)}
                                                                    style={{ paddingLeft: "50px" }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control-1"
                                                                    placeholder="ISD"
                                                                    value={PreMobileAuthorizedPerson}
                                                                    // disabled={isCorrespondenceDetails}
                                                                    onChange={(e) =>
                                                                        this.setState({
                                                                            PreMobileAuthorizedPerson:
                                                                                e.target.value,
                                                                        })
                                                                    }
                                                                    // placeholder={+91}
                                                                    style={{
                                                                        width: "45px",
                                                                        position: "absolute",
                                                                        top: "25px",
                                                                        paddingLeft: "5px",
                                                                    }}
                                                                />
                                                                {
                                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                                        {MobileAuthorizedPersonErr}
                                                                    </span>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr></hr>
                                        </div>

                                        }
                                        {this.state.TandC.length > 0 &&
                                            <div>
                                                <div className="mt-0 ms-2">
                                                    <div className="card-body px-0 py-1 fw-semibold">
                                                        <p>Terms and Conditions</p>
                                                    </div>
                                                    <div className="card-body p-0">
                                                        {this.state.TandC.length > 0 && this.state.TandC.map((data, i) => (
                                                            <div>
                                                                <p> {data.Code}) {data.Description}</p>
                                                                {data.subdata.length > 0 && data.subdata.map((element, i) => (
                                                                    <p className='ms-4 mt-n1'> {element.parent_id}.{element.Code}) {element.Description}</p>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                                <div class="row m-0 mt-0 p-0">
                                                    <form>
                                                        <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                                                            <input type="checkbox"
                                                                checked={this.state.isAgree}
                                                                onChange={(e) => this.setState({ openPop4: true, }, async () => {
                                                                    await this.PdfRender()
                                                                })}
                                                            />
                                                            <spa class="text-primary">I agree all the terms/condition and exhibition rules for India ITME 2026</spa> </label>
                                                    </form>
                                                </div>
                                                <div class="row m-0 mt-0 p-0">
                                                    <form>
                                                        <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                                                            <input type="checkbox"
                                                                checked={this.state.isAgreeConsent}
                                                                onChange={(e) => this.setState({ isAgreeConsent: true, })}
                                                            />
                                                            <spa class="text-primary">By Submitting Exhibitor registration form, I give my consent to India ITME Society to verify the provided information submitted by me online by telephonic call or by Email and also to send me promotional information via digital and offline channels not limited to email, SMS, WhatsApp, print newsletter and invitation card. </spa> </label>
                                                    </form>
                                                </div>
                                            </div>
                                        }
                                    </div>


                                    <button
                                        type="button"
                                        class="btn btn-aqua rounded-1 m-2 mt-3"
                                        style={{ float: 'right' }}
                                        disabled={!this.state.isAgree || !this.state.isAgreeConsent}
                                        // onClick={(e) => this.onSubmit()}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Update?`, buttonName: "Update", action: 0 }, popArg: [] })}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
            <Modal isOpen={openPop4} onRequestClose={e => this.setState({ openPop4: !openPop4 })} onAfterOpen={() => this.PdfRender()}>
                <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                    <div className="modal-content responsive-width w-auto">
                        <div className="modal-header" style={{ padding: "10px 10px" }}>
                            <h5 className="modal-title" id="termsandconLabel">
                                <b>Rules & Regulations</b>
                            </h5>
                            <button style={{ fontSize: '16px' }}
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={e => this.setState({ openPop4: !openPop4 })}
                            />
                        </div>

                        <div className="modal-body" style={{ padding: "0px 12px 9px 12px", height: 'calc(90vh - 200px)', overflow: 'auto', overflowY: 'hidden' }}>
                            {/* <iframe
                                                            id="myIframe" style={{ marginTop: '0px' }}
                                                            src={`${DOC_BASE_URL + RandRpath}#toolbar=0&navpanes=0`}
                                                            width="100%"
                                                            height="100%"
                                                            title="Bing"
                                                        /> */}
                            <div
                                id="pdf-container"
                                ref={this.pdfContainerRef}
                                style={{
                                    width: "100%",
                                    height: "100%",       // keeps it scrollable inside card
                                    overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                    WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                    background: '#f5f5f5'
                                }}
                            ></div>
                        </div>
                        <div className="form-row m-3 mt-2 mb-0 border-bottom">

                            <div className="col-md-10">
                                <p> I have read the space booking Rules and Regulation for "{sessionStorage.getItem("sessionExhibitionName")}" & agree to abide by them.</p>
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-gray"
                                    data-bs-dismiss="modal"
                                    style={{ padding: '4px 15px', float: 'right' }}
                                    onClick={e => this.setState({ isAgree: true, openPop4: false })}
                                >
                                    Accept
                                </button>
                            </div>


                        </div>
                        {/* <div className="modal-footer" style={{ padding: 3 }}>
                        
                                                    </div> */}
                    </div>
                </div>

            </Modal>
            <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                <div className="modal-dialog">
                    <div className="modal-content confirm-logout">
                        <div class="modal-header p-2">
                            <h5 class="modal-title">Confirm Delete</h5>
                            <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isDelOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="pop_label">Do you really want to delete this Document?</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer p-1">
                            <div class="form-group text-right mod-fot">
                                <button type="button" class="btn btn-del-pop"
                                    onClick={(e) => this.handleDelete(e)}
                                >Yes</button>
                                <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDelOpen: false })}>No</button>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
        </>)
    }
}


export default withRouter(connect(null, {
    sendPartnerRegistrationform_action, fill_action, getPartnerStaticData_action, getPartnerApplicationDetails_action, updatePartnerApplication_action, partnerDeleteDoc_action
})(PartnerApplication));